import {aboutPhoto, introPhoto} from "./photo";

export const introData = {
  mainImage: introPhoto,
  opacity: 0.2
}


export const aboutData = {
  asset: aboutPhoto,
  text: "<h1>Location d’appartements et chambres à Saint-Rémy-de-Provence – Adult Only</h1>" +
    "<p>Découvrez nos <strong>appartements et chambres à louer à Saint-Rémy-de-Provence</strong>, <strong>réservés aux adultes</strong>, pour un <strong>séjour calme et relaxant en Provence</strong>. Chaque logement offre <strong>confort moderne, terrasse privée et Wi-Fi haut débit</strong>, dans un cadre paisible avec <strong>jardin ou espaces verts</strong>.</p>" +
    "<p>Idéalement situés, nos logements sont proches des <strong>commerces, restaurants et attractions touristiques de Saint-Rémy-de-Provence</strong>, parfaits pour explorer les <strong>Alpilles, les villages provençaux et les sites culturels de Provence</strong>." +
    "<p>Réservez dès maintenant votre <strong>location d’appartement ou chambre à Saint-Rémy-de-Provence</strong> et profitez du charme unique de la Provence.</p>"
}

export const amenitiesData = {
  amenities: [
    "breakfast",
    "wifi",
    "swimming",
    "wheelchair-way",
    "parking",
    "tv"
  ],
  height: "600px",
  opacity: 0.95,
  asset: {filename: 'https://cdn.residencemelody.com/images/residencemelody.png'},
  title: ""
}

export const accessibilitiesData = [
  {
    icon: "plane",
    entries: [
      "airportMarseille",
      "airportAvignon",
      "airportNimes"
    ]
  },
  {
    icon: "train",
    entries: [
      "trainArles",
      "trainAvignon",
      "trainNimes",
      "trainMarseille"
    ]
  },
  {
    icon: "car",
    entries: [
      "wayFromNorth",
      "wayFromWest",
      "wayFromEst"
    ]
  }
]
